import React, { useEffect, useState } from "react";
import LegalNewsBanner from "../components/LegalNewsBanner";

export default function Lawyers() {
  const [lawyers, setLawyers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchLawyers = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/lawyers`, {
          headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
            Accept: "application/json",
          },
        });
        const data = await res.json();
        if (res.ok) {
          setLawyers(data.lawyers || []);
        } else {
          setError(data.message || "Failed to load lawyers.");
        }
      } catch {
        setError("Network error.");
      }
      setLoading(false);
    };
    fetchLawyers();
  }, [token]);

  return (
    <div className="bg-gray-50 min-h-screen py-8 px-4">
      <LegalNewsBanner />
      <h2 className="text-2xl sm:text-3xl font-bold text-blue-900 mb-6 text-center">
        Featured Lawyers
      </h2>

      {loading && <div className="text-center">Loading...</div>}
      {error && <div className="text-center text-red-600">{error}</div>}
      <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 max-w-5xl mx-auto">
        {lawyers.map((lawyer) => (
          <div
            key={lawyer.id}
            className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center hover:shadow-lg transition-shadow duration-200"
          >
            <img
              src={lawyer.image || "https://randomuser.me/api/portraits/lego/1.jpg"}
              alt={lawyer.name}
              className="h-24 w-24 rounded-full border-4 border-blue-200 mb-4 object-cover"
            />
            <h3 className="text-lg font-semibold text-blue-800">{lawyer.name}</h3>
            <p className="text-sm text-gray-600 mb-1">{lawyer.specialization || "N/A"}</p>
            <p className="text-xs text-gray-400 mb-3">{lawyer.location || "N/A"}</p>
            {token ? (
              <button
                className="bg-blue-700 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-800 transition-colors duration-200"
                onClick={() => window.location.href = `/connect-lawyer?lawyerId=${lawyer.id}`}
              >
                Connect
              </button>
            ) : (
              <button
                className="bg-gray-400 text-white px-4 py-2 rounded-lg shadow cursor-not-allowed"
                onClick={() => window.location.href = "/login"}
              >
                Login to Connect
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
